module.exports = __webpack_public_path__ + "img/mezzo2.3f47e02f.png";